// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"HDBDashboardLayout_dashboardLayout__tiKR2","contentArea":"HDBDashboardLayout_contentArea__bhvQu","subheaderIcons":"HDBDashboardLayout_subheaderIcons__4NMmx"};